import React from "react";
import { formattedDate } from "../../utils/dateUtils";
import { Eye, Download } from "lucide-react";

const AssociationInformation = () => {
  const data = [
    {
      id: 1,
      availablename: "Tom1.Homeowner.PDF",
      filesize: "200kb",
      uploadedDate: "2025-01-21",
      uploadedBy: "Olivia Rhye",
      conact: "+123 551 515",
      address: "520 Buena Vista Ave San Jose CA 94088",
    },
    {
      id: 2,
      availablename: "Tom1.Homeowner.PDF",
      filesize: "324kb",
      uploadedDate: "2025-01-21",
      uploadedBy: "Demi Wilkinson",
      conact: "+123 551 515",
      address: "456  Buena Vista Ave San Jose CA 94088",
    },
    {
      id: 3,
      availablename: "Tom1.Homeowner.PDF",
      filesize: "324kb",
      uploadedDate: "2025-01-21",
      uploadedBy: "Olivia Rhye",
      conact: "+123 551 515",
      address: "520 Buena Vista Ave San Jose CA 94088",
    },
  ];

  return (
    <div className="bg-gray-50 min-h-screen md:p-4">
      <div className="max-w-7xl mx-auto">
        {/* Association Information Section */}
        <div className="flex justify-between items-center mb-6">
          <h1 className="text-2xl font-bold text-gray-800">Association Information</h1>
        </div>

        <div className="bg-white rounded-lg shadow-sm overflow-hidden mb-6">
          <div className="p-6 space-y-6">
            <div className="grid md:grid-cols-2 gap-6">
              <div>
                <h2 className="text-sm font-medium text-gray-500 mb-1">Association Name</h2>
                <p className="text-base font-medium text-gray-900">San Jose HOA</p>
              </div>

              <div>
                <h2 className="text-sm font-medium text-gray-500 mb-1">Association Address</h2>
                <p className="text-base font-medium text-gray-900">1234 Westfield St, San Jose, CA 92345</p>
              </div>
            </div>

            <div>
              <h2 className="text-sm font-medium text-gray-500 mb-2">Board Members</h2>
              <ul className="space-y-1">
                <li className="text-base font-medium text-gray-900">John Cena, Director / 2 yrs.</li>
                <li className="text-base font-medium text-gray-900">Diana May, Board member / 2.5 yrs.</li>
                <li className="text-base font-medium text-gray-900">Dom King, Board member / 1.5 yrs.</li>
              </ul>
            </div>

            <div>
              <h2 className="text-sm font-medium text-gray-500 mb-2">Committee</h2>
              <p className="text-base font-medium text-gray-900">Placeholder</p>
            </div>

            <div>
              <h2 className="text-sm font-medium text-gray-500 mb-2">HOA Members</h2>
              <p className="text-base font-medium text-gray-900">Tony Stark, Steve Ronger.</p>
            </div>
          </div>
        </div>

        {/* Available Documents Section */}
        <div className="flex justify-between items-center mb-6">
          <h1 className="text-2xl font-bold text-gray-800">Available Documents</h1>
          <button className="flex items-center gap-2 px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600">
            <Download size={18} />
            <span>Download</span>
          </button>
        </div>

        <div className="bg-white rounded-lg shadow-sm overflow-hidden mb-6">
          <div className="overflow-x-auto">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-blue-400">
                <tr>
                  <th className="px-6 py-3 text-left text-sm font-medium text-white tracking-wider">Select</th>
                  <th className="px-6 py-3 text-left text-sm font-medium text-white tracking-wider">File Name</th>
                  <th className="px-6 py-3 text-left text-sm font-medium text-white tracking-wider">File Size</th>
                  <th className="px-6 py-3 text-left text-sm font-medium text-white tracking-wider">Uploaded Date</th>
                  <th className="px-6 py-3 text-left text-sm font-medium text-white tracking-wider">Uploaded By</th>
                  <th className="px-6 py-3 text-left text-sm font-medium text-white tracking-wider">Action</th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {data.map((item, index) => (
                  <tr key={item.id} className="hover:bg-gray-50">
                    <td className="px-6 py-4 whitespace-nowrap">
                      <input
                        type="checkbox"
                        className="h-4 w-4 text-blue-500 border-gray-300 rounded focus:ring-blue-500"
                      />
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{item.availablename}</td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{item.filesize}</td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                      {formattedDate(item.uploadedDate)}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{item.uploadedBy}</td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                      <button className="text-blue-500 hover:text-blue-700" title="View Details">
                        <Eye size={18} />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="bg-gray-50 px-6 py-3 border-t border-gray-200">
            <div className="text-sm text-gray-700">
              Showing {data.length} documents
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AssociationInformation;